// Modal padrão do tema "astro": cabeçalho em gradiente com ícone,
// brilho que atravessa, entrada com mola e rodapé fixo.
import React from "react";
import {
  makeStyles,
  Dialog,
  DialogActions,
  DialogContent,
  IconButton,
  Typography
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import { fundoNavy } from "../../utils/estiloNavy";

const useStyles = makeStyles(theme => {
  const escuro = theme.palette.type === "dark";
  return {
    paper: {
      borderRadius: 24,
      overflow: "hidden",
      backgroundColor: escuro ? "#0e1716" : "#f4f7fb",
      border: escuro ? "1px solid rgba(45,212,191,.12)" : "none",
      boxShadow: escuro
        ? "0 30px 80px rgba(0,0,0,.6), 0 0 40px rgba(20,184,166,.10)"
        : "0 30px 80px rgba(15,23,42,.22)",
      animation: "iaModalEntrar .42s cubic-bezier(0.22, 1, 0.36, 1) backwards"
    },
    fundo: {
      // sem backdrop-filter: o desfoque deixava a abertura pesada
      backgroundColor: escuro ? "rgba(2,6,23,.65)" : "rgba(11,18,32,.42)"
    },
    cabecalho: {
      position: "relative",
      overflow: "hidden",
      display: "flex",
      alignItems: "center",
      gap: 16,
      padding: "22px 56px 22px 24px",
      color: "#fff",
      // mesmo azul-noite do Dashboard e dos outros modais
      background: fundoNavy,
      // brilho que passa uma vez ao abrir
      "&::after": {
        content: '""',
        position: "absolute",
        top: 0,
        bottom: 0,
        left: 0,
        width: "30%",
        background: "linear-gradient(90deg, transparent, rgba(255,255,255,.22), transparent)",
        animation: "iaBrilho 1.1s .25s ease-out backwards",
        transform: "translateX(320%) skewX(-20deg)",
        pointerEvents: "none"
      },
      // círculo decorativo
      "&::before": {
        content: '""',
        position: "absolute",
        right: -40,
        top: -60,
        width: 170,
        height: 170,
        borderRadius: "50%",
        border: "1px dashed rgba(255,255,255,.14)",
        pointerEvents: "none"
      }
    },
    bolhaIcone: {
      flexShrink: 0,
      width: 48,
      height: 48,
      borderRadius: 14,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      background: "linear-gradient(135deg, #14b8a6, #0f766e)",
      boxShadow: "0 0 0 3px rgba(255,255,255,.14), 0 8px 22px rgba(0,0,0,.3)",
      animation: "iaIconePop .6s .1s cubic-bezier(0.22, 1, 0.36, 1) backwards",
      "& .MuiSvgIcon-root": { color: "#fff", fontSize: 26 }
    },
    titulo: {
      fontWeight: 800,
      fontSize: "1.12rem",
      lineHeight: 1.25,
      color: "#fff"
    },
    subtitulo: {
      marginTop: 3,
      fontSize: "0.8rem",
      lineHeight: 1.45,
      color: "#94a3b8"
    },
    fechar: {
      position: "absolute",
      top: 12,
      right: 12,
      zIndex: 2,
      color: "#fff",
      backgroundColor: "rgba(255,255,255,.12)",
      transition: "transform .25s ease, background-color .2s ease",
      "&:hover": {
        transform: "rotate(90deg)",
        backgroundColor: "rgba(255,255,255,.24)"
      }
    },
    conteudo: {
      padding: theme.spacing(3),
      ...theme.scrollbarStyles
    },
    acoes: {
      padding: theme.spacing(1.75, 3),
      gap: 8,
      borderTop: `1px solid ${theme.palette.divider}`,
      backgroundColor: escuro ? "#0e1716" : "#ffffff",
      "& > :not(:first-child)": { marginLeft: 0 },
      "& .MuiButton-root": {
        textTransform: "none",
        borderRadius: 12,
        fontWeight: 700,
        padding: "7px 16px"
      },
      "& .MuiButton-containedPrimary": {
        background: "linear-gradient(135deg, #0d9488, #14b8a6)",
        boxShadow: "0 8px 20px rgba(20,184,166,.32)",
        transition: "transform .2s ease, box-shadow .2s ease",
        "&:hover": {
          transform: "translateY(-2px)",
          boxShadow: "0 12px 26px rgba(20,184,166,.42)"
        }
      }
    }
  };
});

const ModalAstro = ({
  open,
  onClose,
  icone,
  titulo,
  subtitulo,
  acoes,
  children,
  maxWidth = "sm",
  paperClassName = "",
  conteudoClassName = "",
  ...resto
}) => {
  const classes = useStyles();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={maxWidth}
      fullWidth
      scroll="paper"
      PaperProps={{ className: `${classes.paper} ${paperClassName}` }}
      BackdropProps={{ className: classes.fundo }}
      {...resto}
    >
      <div className={classes.cabecalho}>
        {icone && <div className={classes.bolhaIcone}>{icone}</div>}
        <div style={{ minWidth: 0, position: "relative", zIndex: 1 }}>
          <Typography className={classes.titulo}>{titulo}</Typography>
          {subtitulo && <Typography className={classes.subtitulo}>{subtitulo}</Typography>}
        </div>
        <IconButton size="small" className={classes.fechar} onClick={onClose}>
          <CloseIcon fontSize="small" />
        </IconButton>
      </div>

      <DialogContent className={`${classes.conteudo} ${conteudoClassName}`}>
        {children}
      </DialogContent>

      {acoes && <DialogActions className={classes.acoes}>{acoes}</DialogActions>}
    </Dialog>
  );
};

export default ModalAstro;
